import { useCallback, useEffect, useState } from 'react';
import { BackToTop } from 'ui/components/1-atoms/Action/BackToTop';
import { useDictionaryContext } from 'application/contexts/DictionaryContext';

const SCROLL_THRESHOLD = 50;

const BackToTopFeature: React.FC = () => {
	const dictionary = useDictionaryContext();
	const scrollDownLabel = dictionary.getValue('Action.BackToTop.ScrollDown', null, 'Scroll ned');
	const scrollTopLabel = dictionary.getValue('Action.BackToTop.ScrollTop', null, 'Tilbage til toppen af siden');

	const [hasScrolled, setHasScrolled] = useState(false);

	useEffect(() => {
		const handleScroll = () => setHasScrolled(window.scrollY > SCROLL_THRESHOLD);
		window.addEventListener('scroll', handleScroll, { passive: true });
		handleScroll();
		return () => window.removeEventListener('scroll', handleScroll);
	}, []);

	const scrollToTop = useCallback(() => {
		window.scrollTo({ top: 0, behavior: 'smooth' });
	}, []);

	const scrollDown = useCallback(() => {
		window.scrollTo({ top: window.innerHeight, behavior: 'smooth' });
	}, []);

	return (
		<BackToTop
			visible={hasScrolled}
			onScrollTop={scrollToTop}
			onScrollDown={scrollDown}
			scrollDownLabel={scrollDownLabel}
			scrollTopLabel={scrollTopLabel}
		/>
	);
};

export default BackToTopFeature;
